import React, { useEffect, Suspense, lazy } from 'react';
import { useMetaPixel } from './components/MetaPixel';
import { HeroSection } from './components/HeroSection';
import { HookSection } from './components/HookSection';
import { AgitationSection } from './components/AgitationSection';
const RevelationSection = lazy(() => import('./components/RevelationSection').then(m => ({
  default: m.RevelationSection
})));
const AuthorSection = lazy(() => import('./components/AuthorSection').then(m => ({
  default: m.AuthorSection
})));
const TestimonialsSection = lazy(() => import('./components/TestimonialsSection').then(m => ({
  default: m.TestimonialsSection
})));
const OfferSection = lazy(() => import('./components/OfferSection').then(m => ({
  default: m.OfferSection
})));
const ClosingSection = lazy(() => import('./components/ClosingSection').then(m => ({
  default: m.ClosingSection
})));
const PricingSection = lazy(() => import('./components/PricingSection').then(m => ({
  default: m.PricingSection
})));
const GuaranteeSection = lazy(() => import('./components/GuaranteeSection').then(m => ({
  default: m.GuaranteeSection
})));
const FAQSection = lazy(() => import('./components/FAQSection').then(m => ({
  default: m.FAQSection
})));
const SalesPopup = lazy(() => import('./components/SalesPopup').then(m => ({
  default: m.SalesPopup
})));
export function App() {
  useMetaPixel();
  useEffect(() => {
    document.title = 'Paz Hormonal';
  }, []);
  return <div className="min-h-screen font-sans bg-brand-cream text-brand-charcoal selection:bg-brand-green/20 selection:text-brand-green" data-id="element-0">
      <main data-id="element-1">
        <HeroSection data-id="element-2" />
        <HookSection data-id="element-3" />
        <AgitationSection data-id="element-4" />
        <Suspense fallback={null} data-id="element-5">
          <RevelationSection data-id="element-6" />
          <AuthorSection data-id="element-7" />
          <TestimonialsSection data-id="element-8" />
          <OfferSection data-id="element-9" />
          <ClosingSection data-id="element-10" />
          <PricingSection data-id="element-11" />
          <GuaranteeSection data-id="element-12" />
          <FAQSection data-id="element-13" />
        </Suspense>
      </main>
      <footer className="bg-brand-charcoal text-white/50 text-center py-6 text-sm border-t border-white/10" data-id="element-14">
        <p data-id="element-15">
          © {new Date().getFullYear()} Paz Hormonal +40. Todos los derechos
          reservados.
        </p>
      </footer>
      <Suspense fallback={null} data-id="element-16">
        <SalesPopup data-id="element-17" />
      </Suspense>
    </div>;
}